/* eslint-disable jsdoc/check-param-names */
import { Dispatch, SetStateAction } from "react";
import { Box, Stack, TextField } from "@mui/material";
import { IncrementalSearchElement } from "./Common";

type Props = {
  label: string;
  value: string;
  options: string[];
  onChange: Function;
  fullWidth?: boolean;
  multiple?: boolean;
  disabled?: boolean
};

/**
 * カスタムテキストフィールド
 * @param label ラベル
 * @param value 値
 * @param options 選択肢
 * @param onChange 値が変わった時の処理
 * @param fullWidth 幅いっぱいにするかどうか
 * @param multiple 複数選択を許可するか
 * @param disabled 非活性
 * @returns JSX.Element
 */
export default function LabeledIncrementalSearch({
  label,
  value,
  options,
  onChange = () => {},
  fullWidth = true,
  multiple,
  disabled,
}: Props) {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      position="relative"
      height={50}
      width={0}
      margin="0 auto"
    >
      <Box textAlign="right" marginRight={1} position="absolute" right={10} width="max-content">
        {label}：
      </Box>
      <Box position="absolute" left={5} width="max-content" minWidth={223}>
        <IncrementalSearchElement
          label={label}
          options={options}
          value={value}
          multiple={multiple}
          fullWidth={fullWidth}
          onChange={onChange}
          disabled={disabled}
        />
      </Box>
    </Stack>
  );
}
